import type { ReactNode } from "react"

import { cn } from "../lib/cn"
import { Card, CardAction, CardContent, CardFooter, CardHeader, CardTitle } from "./Card"

export function CartaoDeGrafico({
  titulo,
  direita,
  atalho,
  rodape,
  classe,
  children,
}: {
  titulo: string
  direita?: ReactNode
  atalho?: ReactNode
  rodape?: ReactNode
  classe?: string
  children: ReactNode
}) {
  return (
    <Card className={cn("min-w-0", classe)}>
      <CardHeader className="items-center">
        <CardTitle className="leading-snug">{titulo}</CardTitle>
        {(direita !== undefined || atalho !== undefined) && (
          <CardAction className="flex items-center gap-2 text-sm text-muted-foreground">
            {direita}
            {atalho}
          </CardAction>
        )}
      </CardHeader>
      <CardContent className="flex-1">{children}</CardContent>
      {rodape !== undefined && (
        <CardFooter className="flex-wrap gap-x-4 gap-y-1 border-t pt-4 text-xs text-muted-foreground">{rodape}</CardFooter>
      )}
    </Card>
  )
}
